/* eslint-env browser */
/* global $ */

const $filters = $('.reference-list-filters');
const $inputs = $filters.find('input');
const filterParams = {};

let $form;

function init() {

	if (!$filters.length) {
		return;
	}

	$form = $filters.find('form');

	$inputs.each(function () {
		filterParams[$(this).attr('name')] = [];
	});

	applyStateFromUrl('industry');

	$filters.on('change', 'input', inputChange);

	$(document).trigger('filter-change.reference-list', [filterParams]);

}

function applyStateFromUrl(type) {

	const searchObj = new URLSearchParams(document.location.search);
	const categories = searchObj.getAll(type);

	if (categories.length) {
		$form.find('input').each(function() {
			$(this).prop('checked', categories.indexOf(this.value) > -1);
		});
	}

	filterParams[type] = getParams(type);

}

function inputChange() {
	const $input = $(this);
	const type = $input.attr('name');
	const value = $input.val();
  const $currentTypeFilters = $inputs.filter(`[name="${type}"]`);

	if (value === '-1') {

		$currentTypeFilters.prop('checked', false);
		$input.prop('checked', true);

	} else {

		$currentTypeFilters.filter('[value="-1"]').prop('checked', false);

		if ($currentTypeFilters.filter(':checked').length < 1) {
			$currentTypeFilters.filter('[value="-1"]').prop('checked', true);
		}

	}

	filterParams[type] = getParams(type);
	filterParams[type] = filterParams[type].filter((value) => value !== '-1');

	const searchParams = filterParams[type].length ? `?industry=${filterParams[type].join('&industry=')}` : '?';

  window.history.replaceState(null, null, searchParams);

	$(document).trigger('filter-change.reference-list', [filterParams]);

}

function getParams(type) {

	const $currentTypeFilters = $inputs.filter(`[name="${type}"]`);
	const $currentlyChecked = $currentTypeFilters.filter(':checked');
	const filterParams = [];

	$.each($currentlyChecked, function () {
		if (this.value !== '-1') {
			filterParams.push($(this).val());
		}
	});

	return filterParams;

}

export default {
	init
};
